import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useConfigStore } from '~/stores/useConfigStore'

export function useMenuVisibility() {
  const { locale } = useI18n()
  const configStore = useConfigStore()
  const { userConfiguration: customerConfiguration } = storeToRefs(configStore)

  const showAudio = computed(() => {
    return false
    // return locale.value === 'da' && 
    //        customerConfiguration.value?.get('audio.show') === true
  })

  const showRadio = computed(() => {
    return locale.value === 'da' && 
           customerConfiguration.value?.get('radio.show') === true
  })

  return {
    showAudio,
    showRadio
  }
} 